import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

import { getShouldNotifyBugSnag } from '@/helpers/reporter';
import { useAuthStore } from '@/stores/auth';
import { useGlobalStore } from '@/stores/global';

export default {
  install: (app: any) => {
    const currentUser = useAuthStore().getFullUser;

    Bugsnag.start({
      apiKey: '64e2b414243d0b1d143736eff8d62cb7',
      plugins: [new BugsnagPluginVue()],
      enabledReleaseStages: ['prod', 'preprod'],
      releaseStage: useGlobalStore().getEnvironment,
      autoDetectErrors: true,
      onError(event) {
        const IGNORED_MESSAGES = [
          'Network Error',
          'canceled',
          'Request aborted',
          'ResizeObserver loop',
          'timeout exceeded'
        ];

        const shouldIgnoreFromMessage = IGNORED_MESSAGES.some(message => {
          if (event?.originalError?.message && typeof event?.originalError?.message === 'string') {
            return event?.originalError?.message?.includes(message);
          } else if (event.originalError && typeof event.originalError === 'string') {
            return event.originalError?.includes(message);
          }
          return false;
        });
        const shouldIgnore = shouldIgnoreFromMessage || !getShouldNotifyBugSnag(event.originalError.response);
        if (shouldIgnore) {
          return false;
        }

        event.addMetadata('user', {
          uuid: currentUser?.uuid,
          email: currentUser?.email
        });
      }
    });

    app.use(Bugsnag.getPlugin('vue'));
  }
};
